// -----------------------------
// splide系
// -----------------------------
if (document.querySelector(".js-certificate-slide") != null) {
  var certificateSlide = new Splide( '.js-certificate-slide', {
    // type:ループ
    // type  : 'loop',

    perPage: 1,
    gap: 30,
    rewind : true,
    
    // 自動再生
    autoplay: true,
    interval:4000, // 自動再生の間隔
    pauseOnHover: false,

    speed: 500,

    // 矢印カスタマイズ
    arrows:true,
    // ページネーションカスタマイズ
    pagination:true,

  } );

  certificateSlide.mount();

  const certSliderEl = document.querySelector('.js-certificate-slide');
  const certArrowSvg = `<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.26182 15.4117L1.76182 8.58672L8.26182 1.76172M1.76182 8.58672L17.3618 8.58672" stroke="currentColor" stroke-width="3.52333" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const certPrevArrow = certSliderEl.querySelector('.splide__arrow--prev');
  const certNextArrow = certSliderEl.querySelector('.splide__arrow--next');
  if (certPrevArrow) certPrevArrow.innerHTML = certArrowSvg;
  if (certNextArrow) certNextArrow.innerHTML = certArrowSvg;
}

if (document.querySelector(".js-voice-slide") != null) {
  var voiceSlide = new Splide( '.js-voice-slide', {
    // type:ループ
    // type  : 'loop',

    perPage: 1,
    gap: 30,
    rewind : true,
    
    // 自動再生
    autoplay: true,
    interval:4000, // 自動再生の間隔
    pauseOnHover: false,

    speed: 500,

    // 矢印カスタマイズ
    arrows:true,
    // ページネーションカスタマイズ
    pagination:true,
  } );

  voiceSlide.mount();

  const voiceSliderEl = document.querySelector('.js-voice-slide');
  const voiceArrowSvg = `<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.26182 15.4117L1.76182 8.58672L8.26182 1.76172M1.76182 8.58672L17.3618 8.58672" stroke="currentColor" stroke-width="3.52333" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const voicePrevArrow = voiceSliderEl.querySelector('.splide__arrow--prev');
  const voiceNextArrow = voiceSliderEl.querySelector('.splide__arrow--next');
  if (voicePrevArrow) voicePrevArrow.innerHTML = voiceArrowSvg;
  if (voiceNextArrow) voiceNextArrow.innerHTML = voiceArrowSvg;
}